import * as React from "react";
import { useCallback, useContext, useEffect } from "react";
import { Box, Grid, Link, Tooltip } from "@mui/material";
import ReactPlayer from "react-player/youtube";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as moment from "moment";
import { WhatsApp, Instagram, AccessTime, Email } from "@mui/icons-material";

import pageStyles from "./ProfileVideosStyles";
import HeaderImage from "assets/images/header_profile_videos.png";
import ProfilePlaceholder from "assets/icons/profile_placeholder.svg";
import PlayCircleImage from "assets/icons/play_circle.svg";
import { ElementsParallax, AdsComponent } from "components";
import { useChannel } from "services";
import { VideoInfoProps } from "models";
import Model from "hooks/Model";
import { Store } from "hooks/main_store";
import { translateMonth } from "utils/validations";

function ProfileVideosScreen() {
  const styles = pageStyles();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { state } = useContext(Store);

  const channel = searchParams.get("channel") || "froin";

  const { loading, channelInfo, recommendedVideos } = useChannel({ channel });

  const showWaiting = useCallback(
    (id: string) => {
      const lastDatePlayed = state.rankingHistory?.[id];
      const countSeconds = moment().diff(
        moment(lastDatePlayed, "x"),
        "seconds",
      );

      return lastDatePlayed && countSeconds < 86400;
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [state.rankingHistory],
  );

  const renderVideos = () =>
    recommendedVideos.map(
      ({
        id,
        url,
        imageUrl,
        created,
        name,
        description,
        visits,
      }: VideoInfoProps) => (
        <Grid item className={styles.itemPlayer} key={id}>
          <Box
            className={styles.itemImgPlayer}
            onClick={() => navigate(`/detail-video?id=${id}`)}
          >
            {imageUrl ? (
              <img src={imageUrl} className={styles.imageVideo} alt="Video" />
            ) : (
              <ReactPlayer
                url={url}
                light
                width="100%"
                height="100%"
                playing={false}
                playIcon={<></>}
              />
            )}
            <div className={styles.overlayPlayer}>
              <img
                alt="Play"
                className={styles.iconPlayer}
                src={PlayCircleImage}
              />
            </div>
            {moment().diff(moment(created, "x"), "d") < 7 ? (
              <div className={styles.newBadge}>Recien agregado</div>
            ) : (
              <></>
            )}
            {showWaiting(id) && (
              <Tooltip title="Aún debes esperar para reproducirlo">
                <div className={styles.iconWaiting}>
                  <AccessTime />
                </div>
              </Tooltip>
            )}
          </Box>
          <h3 className={styles.itemNamePlayer}>{name}</h3>
          <p className={styles.itemDescriptionPlayer}>{description}</p>
          <p className={styles.itemDescriptionPlayer}>
            {translateMonth(moment(created, "x").format("DD MMMM YYYY"))}
          </p>
        </Grid>
      ),
    );

  useEffect(() => {
    if (!loading && !channel) {
      navigate("/");
    } else if (!loading && !state.loading) {
      Model.setData("layoutConfig", { withBg: true });
      Model.setData("stepTutorial", "profile-videos");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, state.loading]);

  return (
    <>
      <ElementsParallax variant="leftBg" />
      <ElementsParallax variant="rightBg" />

      <div
        className={styles.bannerContainer}
        style={{
          backgroundImage: `url(${channelInfo?.banner || HeaderImage})`,
        }}
      >
        <div className={styles.containerProfileImage}>
          <img
            alt="profile"
            className={[
              styles.profileImage,
              channelInfo?.image ? styles.bgWhite : "",
            ].join(" ")}
            src={channelInfo?.image || ProfilePlaceholder}
          />
        </div>
        <div className={styles.containerInfo}>
          <h3 className={styles.nameProfile}>{channelInfo?.name}</h3>
          <p className={styles.descriptionProfile}>
            {channelInfo?.description}
          </p>
          <Link className={styles.ctaProfile} href="/" title="Nosotros">
            Ver más sobre nosotros
          </Link>
        </div>
        <div className={styles.rowSocialProfile}>
          <a href="https://wa.me/573012069045" title="Escríbenos a WhatsApp">
            <WhatsApp />
          </a>
          <a
            href="https://www.instagram.com/froin.club/"
            title="Visítanos en Instagram"
          >
            <Instagram />
          </a>
          <a href="mailto:hello@froin.co" title="Envíanos un correo">
            <Email />
          </a>
        </div>
      </div>

      <AdsComponent />

      <Box sx={{ position: "relative" }}>
        <p className={styles.label}>{"🤩"} Reproduce, apoya y gana</p>
        <Box
          id="containerListPlayer"
          sx={{
            position: "absolute",
            width: "100%",
            zIndex: -1,
            height: "40vh",
            top: 0,
            left: 0,
          }}
        />
      </Box>
      <Grid container className={styles.containerListPlayer}>
        {renderVideos()}
      </Grid>
    </>
  );
}

export default ProfileVideosScreen;
